import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/** Fades + slides children in once they scroll into view (static when reduced motion is on). */
const SectionReveal = ({ children, className, delay = 0, id }) => {
  const reduce = useReducedMotion();

  if (reduce) {
    return (
      <div id={id} className={className}>
        {children}
      </div>
    );
  }

  return (
    <motion.div
      id={id}
      className={className}
      initial={{ opacity: 0, y: 26 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.6, delay, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  );
};

export default SectionReveal;
